export const workData = [
  {
    image: require("../../assets/skills-icons/react-icon.png"),
    name: "React",
  },
  {
    image: require("../../assets/skills-icons/redux-icon.png"),
    name: "Redux",
  },
  {
    image: require("../../assets/skills-icons/ts-icon.png"),
    name: "TypeScript",
  },
  {
    image: require("../../assets/skills-icons/js-icon.png"),
    name: "JavaScript",
  },
  {
    image: require("../../assets/skills-icons/html-icon.png"),
    name: "HTML",
  },
  {
    image: require("../../assets/skills-icons/css-icon.png"),
    name: "CSS",
  },
  {
    image: require("../../assets/skills-icons/sass-icon.png"),
    name: "Sass",
  },
  {
    image: require("../../assets/skills-icons/jest-icon.png"),
    name: "Jest",
  },
  {
    image: require("../../assets/skills-icons/git-icon.png"),
    name: "Git",
  },
  {
    image: require("../../assets/skills-icons/npm-icon.png"),
    name: "Npm",
  },
  {
    image: require("../../assets/skills-icons/node-icon.png"),
    name: "Node Js",
  },
  {
    image: require("../../assets/skills-icons/express-icon.png"),
    name: "Express",
  },
  {
    image: require("../../assets/skills-icons/postgres-icon.png"),
    name: "PostgreSQL",
  },
  {
    image: require("../../assets/skills-icons/sequelize-icon.png"),
    name: "Sequelize",
  },
  {
    image: require("../../assets/skills-icons/socket-icon.png"),
    name: "Socket.io",
  },
  {
    image: require("../../assets/skills-icons/figma-icon.png"),
    name: "Figma",
  },
  {
    image: require("../../assets/skills-icons/spline-icon.png"),
    name: "Spline",
  },
  {
    image: require("../../assets/skills-icons/canvas-icon.png"),
    name: "Canvas-Sketch",
  },
];
